import { dataHooks } from '@wix/data-hooks'

export const wixMobileCategorySuggestionsDataHooks = dataHooks<{
  suggestion: { key: string }
}>('wix-mobile-category-suggestions')
